import type { Project } from '@/types/project';

export const projects: Project[] = [
  {
    id: '1',
    title: 'E-commerce Platform',
    description: 'Modern e-commerce solution with advanced features',
    longDescription:
      'A comprehensive e-commerce platform built with Next.js, featuring real-time inventory management, secure payment processing, and advanced analytics. Includes admin dashboard, customer portal, and mobile-responsive design.',
    image: '/assets/projects/modern-e-commerce.png',
    technologies: [
      'Next.js',
      'TypeScript',
      'Stripe',
      'PostgreSQL',
      'Tailwind CSS',
    ],
    githubUrl: 'https://github.com/yourusername/ecommerce-platform',
    liveUrl: 'https://your-ecommerce-platform.vercel.app',
    category: 'web',
    featured: true,
    year: 2024,
  },
  {
    id: '2',
    title: 'AI Content Generator',
    description: 'AI-powered content creation tool',
    longDescription:
      "An innovative AI content generator that leverages OpenAI's GPT models to create high-quality blog posts, social media content, and marketing copy. Features customizable templates, tone adjustment, and content optimization.",
    image: '', // ✅ Intentionally empty
    technologies: ['React', 'OpenAI API', 'Node.js', 'MongoDB', 'Tailwind CSS'],
    githubUrl: 'https://github.com/yourusername/ai-content-generator',
    liveUrl: 'https://ai-content-generator-demo.vercel.app',
    category: 'ai',
    featured: true,
    year: 2024,
  },
  {
    id: '3',
    title: 'Mobile Banking App',
    description: 'Secure mobile banking application',
    longDescription:
      'A feature-rich mobile banking application built with React Native, providing secure account management, real-time transactions, biometric authentication, and investment tracking. Includes offline capabilities and push notifications.',
    image: '/assets/projects/mobile-banking.png',
    technologies: ['React Native', 'TypeScript', 'Firebase', 'Stripe', 'Expo'],
    githubUrl: 'https://github.com/yourusername/mobile-banking-app',
    liveUrl: 'https://expo.dev/@yourusername/mobile-banking-app',
    category: 'mobile',
    featured: false,
    year: 2023,
  },
  {
    id: '4',
    title: 'Task Management System',
    description: 'Collaborative project management tool',
    longDescription:
      'A comprehensive task management system designed for teams, featuring real-time collaboration, advanced filtering, time tracking, and reporting. Built with a microservices architecture and includes mobile apps.',
    image: '/assets/projects/task-management-system.png',
    technologies: ['Next.js', 'GraphQL', 'PostgreSQL', 'Redis', 'Docker'],
    githubUrl: 'https://github.com/yourusername/task-management-system',
    liveUrl: 'https://task-management-system.vercel.app',
    category: 'web',
    featured: true,
    year: 2023,
  },
  {
    id: '5',
    title: 'Weather Dashboard',
    description: 'Real-time weather tracking application',
    longDescription:
      'A responsive weather dashboard that provides real-time weather data, forecasts, and historical analysis. Features interactive maps, customizable alerts, and integration with multiple weather APIs.',
    image: '/assets/projects/weather-dashboard.png',
    technologies: ['React', 'OpenWeatherMap API', 'Chart.js', 'Tailwind CSS'],
    githubUrl: 'https://github.com/yourusername/weather-dashboard',
    liveUrl: 'https://weather-dashboard-demo.vercel.app',
    category: 'web',
    featured: false,
    year: 2023,
  },
  {
    id: '6',
    title: 'Modern Portfolio Website',
    description: 'Personal portfolio showcasing projects and skills',
    longDescription:
      'A modern portfolio website built with Next.js, featuring a clean design, project showcase, blog section, and contact form. Includes animations, responsive design, and SEO optimization.',
    image: '/assets/projects/modern-portfolio.png',
    technologies: [
      'Next.js',
      'TypeScript',
      'Tailwind CSS',
      'Framer Motion',
      'Sonner',
    ],
    githubUrl: 'https://github.com/yourusername/modern-portfolio',
    liveUrl: 'https://your-portfolio.vercel.app',
    category: 'web',
    featured: false,
    year: 2024,
  },
  {
    id: '7',
    title: 'Action Game',
    description: 'Fast-paced action game with multiplayer support',
    longDescription:
      'An action-packed multiplayer game built with Phaser.js, featuring real-time combat, power-ups, and leaderboards. Includes single-player mode and supports cross-platform play.',
    image: '/assets/projects/action-game.png',
    technologies: ['Phaser.js', 'Node.js', 'Socket.IO', 'HTML5 Canvas'],
    githubUrl: 'https://github.com/yourusername/action-game',
    liveUrl: 'https://action-game-demo.vercel.app',
    category: 'game',
    featured: false,
    year: 2022,
  },
];
